"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetChildInfoAllOfCredits {
    static getAttributeTypeMap() {
        return GetChildInfoAllOfCredits.attributeTypeMap;
    }
}
GetChildInfoAllOfCredits.discriminator = undefined;
GetChildInfoAllOfCredits.attributeTypeMap = [
    {
        "name": "emailCredits",
        "baseName": "emailCredits",
        "type": "number"
    },
    {
        "name": "smsCredits",
        "baseName": "smsCredits",
        "type": "number"
    }
];
exports.GetChildInfoAllOfCredits = GetChildInfoAllOfCredits;
//# sourceMappingURL=getChildInfoAllOfCredits.js.map